import React, { useState } from 'react';

import { Button } from '@components/common';
import { ExportCsvModal } from '@components/shared/ExportCsvModal';
import { Tooltip } from '@components/Tooltip';
import { usePermission } from '@hooks/usePermission';

export const CsvExport: React.FC<
  React.PropsWithChildren<{
    q?: string;
    filters?: string[];
    sort?: string;
    sortDesc?: boolean;
  }>
> = ({ q, filters, sort, sortDesc }) => {
  const [open, setOpen] = useState<boolean>(false);
  const isAdmin = usePermission('isAdmin')();

  const params = {
    kind: 'incentives' as const,
    query: {
      q,
      filters,
      sort,
      sort_desc: sortDesc
    }
  };

  if (!isAdmin) {
    return (
      <Tooltip content='Only admin users may export incentives'>
        <div>
          <Button disabled aria-label='Export CSV' iconSuffix='export' medium>
            Export CSV
          </Button>
        </div>
      </Tooltip>
    );
  }

  return (
    <>
      <Button aria-label='Export CSV' iconSuffix='export' medium onClick={() => setOpen(true)}>
        Export CSV
      </Button>
      {open && <ExportCsvModal setOpen={setOpen} subjectString='incentives' params={params} />}
    </>
  );
};

export const CsvExportButton: React.FC<
  React.PropsWithChildren<{
    q?: string;
    filters?: string[];
    sort?: string;
    sortDesc?: boolean;
  }>
> = (props) => {
  return <CsvExport {...props} />;
};
